import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import Refresh from '@material-ui/icons/Refresh';

import { useDispatch } from 'react-redux';

import { refrescarUltimasAutorizaciones } from '../../redux/actions/autorizacionActions';

const useStyles = makeStyles((theme) => ({
  boton: {
    position: 'fixed',
    right: '20px',
    bottom: '100px',
    color: '#ffffff',
    background: '#585858',
    zIndex: 1,
  },
}));

export default function FloatingActionButtons({ token }) {
  const classes = useStyles();

  const dispatch = useDispatch();

  const handleRefresh = () => {
    dispatch(refrescarUltimasAutorizaciones(token));
  };

  return (
    <>
      <Fab
        // color='primary'
        aria-label='refresh'
        className={classes.boton}
        onClick={handleRefresh}
      >
        <Refresh />
      </Fab>
    </>
  );
}
